import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../components/CartDrawer';
import { sampleProductsPath } from '../lib/paths';

export default function CheckoutPage() {
  const { items, clear } = useCart();
  const total = items.reduce((sum, item) => sum + item.price * item.quantity, 0);

  useEffect(() => {
    document.title = 'Checkout | Nyafaz Skincare';
  }, []);

  return (
    <main className="page">
      <section className="hero">
        <span className="badge">Demo checkout</span>
        <h1>Checkout</h1>
        <p>This is a dummy checkout page used for the sample products demo shop.</p>
      </section>
      <section className="section-card" style={{ marginTop: 0 }}>
        <h2>Total: ₹{total}</h2>
        <p className="muted">{items.length ? `${items.length} item(s) in cart` : 'Your cart is empty.'}</p>
        <div className="actions" style={{ marginTop: 18 }}>
          <button className="btn" type="button" onClick={clear} disabled={!items.length}>
            Place Demo Order
          </button>
          <Link className="btn secondary" to={sampleProductsPath('/products')}>
            Continue Shopping
          </Link>
        </div>
      </section>
    </main>
  );
}
